import { isNumber } from './numbers';
import { isFunction } from './object';

/**
 * A wrapper function around setTimeout. It wraps the task in a closure to
 * prevent unsafe-eval of strings. This is mainly here to encourage thoughtful
 * use of setTimeout, and we may introduce features around task queuing to
 * further improve performance.
 * @param {Function} task to defer/execute
 * @param {Number} timeout minimum wait time in ms before executing
 * @return {Number} the id from the setTimeout
 */
export const deferTask = (task, timeout = 0) => {
  // TODO(lemieux) consider refactoring so that this actually uses a Task, have Task use setTimeout.
  if (!isFunction(task)) {
    throw new Error("Unable to defer a task that isn't a function");
  }

  if (!isNumber(timeout) || timeout < 0) {
    throw new Error(
      'Invalid timeout. If passed, it must be a non-negative number.',
    );
  }

  // Adding a name for better debugging
  const deferTaskHandler = () => {
    task();
  };

  return setTimeout(deferTaskHandler, timeout);
};

/**
 * A wrapper function around clearTimeout.
 * @param {Number} setTimeout ID to cancel.
 */
export const cancelTask = (timeoutId) => {
  // TODO(lemieux) consider refactoring so that this actually uses a Task, have Task use clearTimeout.
  if (!isNumber(timeoutId)) {
    throw new Error('Invalid timeoutId. If passed, it must be a number.');
  }

  return clearTimeout(timeoutId);
};

export const inWorker = !self.document;

export const isWorkerCreationSupported = self.hasOwnProperty('Worker');
